window.addEventListener('load', function() {
	// Remove visibility: hidden; for CLS
	body.style = '';

	var stickyHeader = new Waypoint({
		element: document.querySelector('.homepage-hero .box .content-wrapper') ?? document.querySelector('main'),
		handler: function(direction) {
			var down = direction == 'down';

			if(down)
				body.classList.add('sticky');
			else
				body.classList.remove('sticky');
		},
		offset: header.offsetHeight
	});
});

var lastScrollTop = 0;

window.addEventListener('scroll', function() {
	if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > lastScrollTop)
			topbar.classList.add('hide');
		else
			topbar.classList.remove('hide');

		lastScrollTop = st <= 0 ? 0 : st;
	}
});

let annClose = document.getElementById('announcement-close');
let topbar = document.getElementById('topbar');

if(annClose){
    annClose.addEventListener('click', function() {

        if(topbar.classList.contains('closed')){
            topbar.classList.remove('closed');
        } else {
            topbar.classList.add('closed');
        }

    });
}

